<template>
  <div class="o-object-profile--portrait">
    <div
      class="o-object-profile__full-bleed-wrapper"
      :style="{ 'background-color': backgroundColor }"
    >
      <div class="o-object-profile--portrait__columns">
        <div class="o-object-profile--portrait__column-left">
          <div class="o-object-profile--portrait__object-number">
            <slot name="objectNumber" />
          </div>
          <div class="o-object-profile--portrait__title">
            <slot name="title" />
          </div>
          <div v-if="isMobile" class="o-object-profile--portrait__viewer">
            <slot name="viewer" />
            <div class="o-object-profile--portrait__fallback">
              <slot name="fallback" />
            </div>
          </div>
          <div class="o-object-profile--portrait__description">
            <slot name="description"></slot>
          </div>
        </div>
        <div class="o-object-profile--portrait__column-right">
          <div v-if="!isMobile" class="o-object-profile--portrait__viewer">
            <slot name="viewer" />
            <div class="o-object-profile--portrait__fallback">
              <slot name="fallback" />
            </div>
          </div>
        </div>
      </div>
      <div class="o-object-profile--portrait__alt-views">
        <slot name="altViews" />
      </div>
    </div>
    <div class="o-object-profile--portrait__part-of">
      <slot name="partOf"></slot>
    </div>
  </div>
</template>

<script>
import { breakpointsMixin } from "@thegetty-private/getty-ui";
import mobileMixin from "@/mixins/mobileMixin/index.js";
export default {
  name: "PortraitView",
  mixins: [breakpointsMixin, mobileMixin],
  props: {
    /**
     * Background color for the component
     */
    backgroundColor: {
      type: String,
      required: false,
      default: undefined
    }
  },
  data() {
    return {
      isMobile: false
    };
  }
};
</script>

<style lang="scss">
@import "./portrait.scss";
</style>
